
import React, { Component } from 'react';
import menuitemutil from '../js/admin/menuitem';
import auth, { avoidMultipleClick, featureEnabled, get, getLocale, getShortName, isDuplicateClickEvent, lighten, settingEnabled } from '../js/auth';
import { getAvailableQuantityLabel } from '../js/chooseMenuItem';
import { orderMenuItem } from '../js/orderMenuItem';
import moment from 'moment';
import { playClickSound } from '../js/order-list-util';
import { notifyMenuTap } from '../js/ai/menuSelector';
import { store } from '..';

class CategoryTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            capacityData: []
        };
        this.intervalRef = null;
    }

    componentDidMount() {
        this.getCapacityFromStore();
        this.intervalRef = setInterval(() => {
            this.getCapacityFromStore();
        }, 5000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalRef);
    }

    getCapacityFromStore = () => {
        const capacityData2 = store.getState()?.rootReducer?.capacity || [];
        if (JSON.stringify(this.state.capacityData) !== JSON.stringify(capacityData2)) {
            this.setState({ capacityData: capacityData2 });
        }
    };

    handleClick = (event) => {
        avoidMultipleClick(null, event);
        //if last value of array categorySelected is the this.props.id then unselect else select
        if (this.props.selectedCategory.includes(this.props.id)) {
            this.props.onUnSelectCategory && this.props.onUnSelectCategory(this.props.id);
        } else {
            this.props.onSelectCategory && this.props.onSelectCategory(this.props.id);
        }
    };

    render() {
        var {
            iid,
            id,
            defaultColor,
            image,
            imageTimestamp,
            name,
            children,
            activeMenuCategories,
            activeMenuItems,
            tmplparams,
            server,
            war,
            myStatus,
            week,
            searchTerm,
            increaseHits,
            autoClickFirst
        } = this.props;

        const { capacityData } = this.state;

        const parentId = `${iid || 0}-${id}`;
        const isSelected = this.props.selectedCategory.includes(this.props.id);
        const isSelected2 = this.props.selectedCategory[this.props.selectedCategory.length - 1] == this.props.id;

        const weekFilter = (c) => !week || moment(c).startOf('week').isSame(moment(week).startOf('week'));

        if (children && children.length > 0) {
            activeMenuCategories = children.filter(c => c.entityType.endsWith('Category'));
            activeMenuItems = children.filter(c => !c.entityType.endsWith('Category'))
        }

        if (!searchTerm && activeMenuCategories.some(cat => this.props.selectedCategory.includes(cat.id))) {
            activeMenuCategories = activeMenuCategories.filter(cat => this.props.selectedCategory.includes(cat.id));
        }

        return (
            <React.Fragment>
                {!searchTerm && (
                    <div
                        id={parentId}
                        key={parentId}
                        className={"parentCategory-0 menuItemCategory " + (isSelected ? "selected2" : "")}
                        onClick={this.handleClick}
                        style={{
                            backgroundColor: defaultColor || undefined,
                            backgroundImage: defaultColor || "#72e104",
                        }}
                    >
                        {!myStatus.restaurant_settings['tables-overview']['show-category-image'] &&
                            image ? (
                            <div
                                    onClick={this.handleClick}
                                className="menuItem-image"
                                style={{
                                    backgroundImage: `url('${server}/${war}/adminService/${localStorage.restaurantSelected}/getImage/${image}?timestamp=${imageTimestamp || 0}')`,
                                }}
                            >
                                <span className="menuItemCategoryLabel withImage">
                                    {getLocale(name, menuitemutil.getLanguage())}
                                </span>
                            </div>
                        ) : (
                            <div style={{ display: 'flex', position: 'relative', flexFlow: 'column', justifyContent: 'center', flexGrow: 1 }}>
                                <span className="menuItemCategoryLabel">{getLocale(name, menuitemutil.getLanguage())}</span>
                            </div>
                        )}
                    </div>)}
                {(searchTerm || isSelected) && (
                    <>
                        {activeMenuCategories &&
                            activeMenuCategories.filter(item => item.isActive && item.isTop && item.defaultPos).map((category) => (
                                <SubcategoryTemplate
                                    capacityData={capacityData}
                                    key={category.id}
                                    iid2={`${parentId}-${category.id}`}
                                    pid={parentId}
                                    d={category}
                                    id={category.id}
                                    {...tmplparams}
                                    week={week}
                                    handleClick={this.handleClick}
                                    searchTerm={searchTerm}
                                    activeMenuCategories={category.activeMenuCategories}
                                    activeMenuItems={category.activeMenuItems}
                                    children={category.children}
                                    increaseHits={increaseHits}
                                    resetSelection={this.props.resetSelection}
                                    selectedCategory={this.props.selectedCategory}
                                    onSelectCategory={this.props.onSelectCategory}
                                    onUnSelectCategory={this.props.onUnSelectCategory}
                                    defaultColor={defaultColor}
                                    autoClickFirst={autoClickFirst}
                                />
                            ))}
                        {activeMenuItems && (searchTerm || isSelected2) &&
                            activeMenuItems.map((item) => {
                                if (item.isActive && item.isTop && item.defaultPos) {
                                    return item.defaultFromDate && item.defaultToDate
                                        ? dateArray(item).filter(weekFilter).map((date, index) => (
                                            <ItemTemplate
                                                capacityData={capacityData}
                                                key={`${item.id}-${index}`}
                                                pid={parentId}
                                                d={{ ...item, defaultFromDate: date }}
                                                {...tmplparams}
                                                week={week}
                                                resetSelection={this.props.resetSelection}
                                                searchTerm={searchTerm}
                                                defaultColor={defaultColor}
                                                increaseHits={increaseHits}
                                                autoClickFirst={autoClickFirst}
                                            />
                                        ))
                                        : (
                                            <ItemTemplate
                                                capacityData={capacityData}
                                                key={item.id}
                                                pid={parentId}
                                                d={item}
                                                {...tmplparams}
                                                week={week}
                                                resetSelection={this.props.resetSelection}
                                                searchTerm={searchTerm}
                                                increaseHits={increaseHits}
                                                defaultColor={defaultColor}
                                                autoClickFirst={autoClickFirst}
                                            />
                                        );
                                }
                                return null;
                            })}
                    </>

                )}
            </React.Fragment>
        );
    }
}


class SubcategoryTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: false
        };
    }

    handleClick = (event) => {
        avoidMultipleClick(null, event);
        //if last value of array categorySelected is the this.props.id then unselect else select
        if (this.props.selectedCategory.includes(this.props.id)) {
            this.props.onUnSelectCategory && this.props.onUnSelectCategory(this.props.id);
        } else {
            this.props.onSelectCategory && this.props.onSelectCategory(this.props.id);
        }
    };

    render() {
        var {
            capacityData,
            iid2,
            pid,
            d,
            level,
            tmplparams,
            server,
            war,
            myStatus,
            defaultColor,
            week,
            searchTerm,
            increaseHits,
            autoClickFirst,
            children,
            activeMenuCategories,
            activeMenuItems

        } = this.props;
        const isSelected = this.props.selectedCategory.includes(this.props.id);
        const isSelected2 = this.props.selectedCategory[this.props.selectedCategory.length - 1] == this.props.id;
        const weekFilter = (c) => !week || moment(c.date).startOf('week').isSame(moment(week).startOf('week'));

        if (children && children.length > 0) {
            activeMenuCategories = children.filter(c => c.entityType.endsWith('Category'));
            activeMenuItems = isSelected2 ? children.filter(c => !c.entityType.endsWith('Category')) : [];
        }

        if (!searchTerm && activeMenuCategories.some(cat => this.props.selectedCategory.includes(cat.id))) {
            activeMenuCategories = activeMenuCategories.filter(cat => this.props.selectedCategory.includes(cat.id));
        }

        return (
            <React.Fragment>
                {!searchTerm && (
                    <div
                        key={iid2}
                        className={`parentCategory-${pid} menuItemCategory " + ${isSelected ? "selected2" : ""}`}
                        onClick={this.handleClick}
                        style={{
                            backgroundColor: d.defaultColor || undefined,
                            backgroundImage: d.defaultColor || "#72e104",
                        }}
                    >
                        {!myStatus.restaurant_settings["tables-overview"]["show-category-image"] &&
                            d.image ? (
                            <div
                                className="menuItem-image"
                                style={{
                                    backgroundImage: `url('${server}/${war}/adminService/${localStorage.restaurantSelected}/getImage/${d.image}?timestamp=${d.imageTimestamp}')`,
                                }}
                            >
                                <span className="menuItemCategoryLabel withImage">
                                    {getLocale(d.name, menuitemutil.getLanguage())}
                                </span>
                            </div>
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    position: "relative",
                                    flexFlow: "column",
                                    justifyContent: "center",
                                    flexGrow: 1,
                                    filter: "inverse(1)",
                                }}
                            >
                                <span className="menuItemCategoryLabel">
                                    {getLocale(d.name, menuitemutil.getLanguage())}
                                </span>
                            </div>
                        )}
                    </div>)}

                {(searchTerm || isSelected) && (
                    <>
                        {/* Render active menu categories */}
                        {activeMenuCategories &&
                            activeMenuCategories.map((category) => {
                                if (category.isActive && category.isTop && category.defaultPos) {
                                    return (
                                        <SubcategoryTemplate
                                            capacityData={capacityData}
                                            key={category.id}
                                            iid2={`${iid2}-${category.id}`}
                                            pid={iid2}
                                            d={category}
                                            id={category.id}
                                            tmplparams={tmplparams}
                                            server={server}
                                            war={war}
                                            activeMenuCategories={category.activeMenuCategories}
                                            activeMenuItems={category.activeMenuItems}
                                            children={category.children}
                                            searchTerm={searchTerm}
                                            increaseHits={increaseHits}
                                            resetSelection={this.props.resetSelection}
                                            selectedCategory={this.props.selectedCategory}
                                            onSelectCategory={this.props.onSelectCategory}
                                            onUnSelectCategory={this.props.onUnSelectCategory}
                                            myStatus={myStatus}
                                            defaultColor={defaultColor}
                                            autoClickFirst={autoClickFirst}
                                        />
                                    );
                                }
                                return null;
                            })}

                        {/* Render active menu items */}
                        {activeMenuItems && (searchTerm || isSelected2) &&
                            activeMenuItems.filter(weekFilter).map((item) => {
                                if (item.isActive && item.isTop && item.defaultPos) {
                                    return item.defaultFromDate && item.defaultToDate
                                        ? dateArray(item).map((date, index) => (
                                            <ItemTemplate
                                                capacityData={capacityData}
                                                key={`${item.id}-${index}`}
                                                pid={iid2}
                                                d={{ ...item, defaultFromDate: date }}
                                                {...tmplparams}
                                                week={week}
                                                searchTerm={searchTerm}
                                                increaseHits={increaseHits}
                                                resetSelection={this.props.resetSelection}
                                                defaultColor={defaultColor}
                                                autoClickFirst={autoClickFirst}
                                            />
                                        ))
                                        : (
                                            <ItemTemplate
                                                capacityData={capacityData}
                                                key={item.id}
                                                pid={iid2}
                                                d={item}
                                                {...tmplparams}
                                                resetSelection={this.props.resetSelection}
                                                searchTerm={searchTerm}
                                                increaseHits={increaseHits}
                                                defaultColor={defaultColor}
                                                autoClickFirst={autoClickFirst}
                                            />
                                        );
                                }
                                return null;
                            })}

                    </>
                )}
            </React.Fragment>
        );
    }
}

export class ItemTemplate extends Component {
    handleOrderClick = (event, entityType, id, quantity = undefined) => {
        if (isDuplicateClickEvent(event)) return;
        avoidMultipleClick(event.currentTarget, event);
        event.stopPropagation();
        notifyMenuTap({ id, entityType, quantity });
        orderMenuItem(event.currentTarget, entityType, id, quantity, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined).done(() => {
            if (this.props.searchTerm)
                this.props.resetSelection && this.props.resetSelection();
        });
    };

    getBackground(q) {
        const { capacityData, d } = this.props;
        if (!capacityData) return "unset";
        var cap = 0;
        const capacity = capacityData[d.id + "-" + q];
        if (capacity?.c > 0) {
            cap = Math.floor(Math.min(10, capacity.c)) * 10;
        }
        return capacityData ? `linear-gradient(to right, #80808029 0%, #8080802e ${cap - 3}%, #8080802e ${cap - 3}%, #808080 ${cap}%, transparent ${cap}%, transparent 100%)` : "unset";
    }

    getCapacity(q) {
        const { capacityData, d } = this.props;
        var cap = 0;
        if (capacityData) {
            const capacity = capacityData[d.id + "-" + q];
            if (capacity?.c > 0) {
                cap = Math.floor(capacity.c);
            }
        }
        else return "unset";
        return cap < 0 ? "-" : Math.min(10, cap) + (cap > 10 ? "+" : "");
    }

    isUnavailable = () => {
        const { d } = this.props;
        if (!d) return false;
        const isProductUnavailable = d.available === false || d.available === "false" || d.available === 0;
        const noAvailableQuantityOnMenu = Array.isArray(d.availableQuantities) && d.availableQuantities.length > 0 && d.availableQuantities.every(q => q?.onMenu === false);
        return isProductUnavailable || noAvailableQuantityOnMenu;
    };

    render() {
        const { capacityData, d, pid, server, war, myStatus, defaultColor, searchTerm, week } = this.props;
        const capacity = capacityData && Object.keys(capacityData).length > 0;
        const availabilityPlatformsEnabled = featureEnabled('ordering') || featureEnabled('foodpanda') || featureEnabled('wolt') || featureEnabled('kiosk') || featureEnabled('choiceqr');
        const unavailable = availabilityPlatformsEnabled && this.isUnavailable();
        const unavailableLabel = getLocale({
            hu: "Nem rendelhető",
            en: "Not available",
            it: "Non disponibile",
            de: "Nicht verfügbar"
        }, menuitemutil.getLanguage());
        if (searchTerm) {
            //check if search term is in name or manufacturer or labels or barcodes
            var searchTermLower = searchTerm.toLowerCase();
            if (searchTermLower.length === 13 && searchTermLower.startsWith('28')) {
                searchTermLower = searchTermLower.substring(2, 7);
            }

            const barcodeSearch = searchTermLower.startsWith('.') ? Number(searchTermLower.substring(1)) : Number(searchTermLower) > 10000 ? Number(searchTermLower) : null;
            if (barcodeSearch) {
                const barcodesMatch = d.barcodes && d.barcodes.some(barcode => barcode.id == barcodeSearch);
                if (!barcodesMatch) {
                    return null;
                }
            } else {
                const nameMatch = getShortName(d).toLowerCase().includes(searchTermLower);
                const manufacturerMatch = d.manufacturer && d.manufacturer.toLowerCase().includes(searchTermLower);
                const labelsMatch = d.labels && d.labels.some(label => label.name.toLowerCase().includes(searchTermLower));
                if (!(nameMatch || manufacturerMatch || labelsMatch)) {
                    return null;
                }
            }
        }
        if (week && d.defaultFromDate) {
            const weekStart = moment(week).startOf('week');
            const weekEnd = moment(week).endOf('week');
            const day = moment(d.defaultFromDate);
            if (day.isAfter(weekEnd) || day.isBefore(weekStart)) {
                return null;
            }
        }
        if (!d.defaultFromDate ||
            d.defaultFromDate >= moment().startOf("day").valueOf()) {
            return (
                <li
                    date={d.defaultFromDate}
                    column={"" + moment(d.defaultFromDate).isoWeekday()}
                    week={"" + moment(d.defaultFromDate).week()}
                    className={`parentCategory-${pid} categoryContent menuItem variationHead list-group-item`}
                    //entityType={d.entityType}
                    //menuItem={d.id}
                    key={`${pid}-${d.id}`}
                    menuitem={d.id}
                    style={{
                        backgroundColor: unavailable ? "#d3d3d3" : (d.defaultColor || defaultColor || "#72e104"),
                        gridColumnStart: d.defaultFromDate ? (moment(d.defaultFromDate).isoWeekday() + 1) : undefined,
                    }}
                >
                    <div>
                        <div
                            className="menuItemHead"
                            onClick={(event) =>
                                this.handleOrderClick(event, d.entityType, d.id, undefined)
                            }
                        >
                            {!myStatus.restaurant_settings["tables-overview"][
                                "show-menuitem-image"
                            ] && d.image ? (
                                <div
                                    className="menuItem-image"
                                    style={{
                                        backgroundImage: `url('${server}/${war}/adminService/${localStorage.restaurantSelected}/getImage/${d.image}?timestamp=${d.imageTimestamp}')`,
                                    }}
                                >
                                    <div style={{ position: "relative" }}>
                                        <span className="menuItem-name2">
                                                {getShortName(d)}
                                            </span>
                                            <span className="menuItem-name">
                                            {getShortName(d)}
                                        </span>
                                    </div>
                                    <span className="manufacturer">{d.manufacturer}</span>
                                    {d.labels?.length > 0 && (
                                        <div className="label">
                                            {d.labels.map((label, index) => (
                                                <span key={index}>{label.name}</span>
                                            ))}
                                        </div>
                                    )}
                                    {d.barcodes?.map((barcode, index) => (
                                        <div
                                            key={index}
                                            style={{ display: "none" }}
                                            className="barcode"
                                            value={barcode.id}
                                        />
                                    ))}
                                </div>
                            ) : (
                                <>
                                    <div style={{ flexGrow: 1 }} />
                                    <span>
                                        {getShortName(d)}
                                    </span>
                                    <span className="manufacturer">{d.manufacturer}</span>
                                    {d.labels?.length > 0 && (
                                        <div className="label">
                                            {d.labels.map((label, index) => (
                                                <span key={index}>{label.name}</span>
                                            ))}
                                        </div>
                                    )}
                                    {d.barcodes?.map((barcode, index) => (
                                        <div
                                            key={index}
                                            style={{ display: "none" }}
                                            className="barcode"
                                            value={barcode.id}
                                        />
                                    ))}
                                    <div style={{ flexGrow: 1 }} />
                                </>
                            )}
                            {unavailable && (
                                <div style={{
                                    marginTop: "4px",
                                    fontSize: "0.72rem",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    color: "#4b4b4b",
                                    letterSpacing: "0.02em"
                                }}>
                                    <span className="icon-availability" style={{ marginRight: "6px" }} />
                                    {unavailableLabel}
                                </div>
                            )}
                        </div>
                        {d.availableQuantities?.map((quantity, index) => {
                            //check if there is an active promotion for this quantity
                            const promotionName = quantity.promotionName;
                            const promotionPrice = quantity.promotionPrice;
                            const promotionStart = quantity.promotionStart;
                            const promotionEnd = quantity.promotionEnd;
                            const activePromotion = moment().isSameOrAfter(moment(promotionStart)) && moment().isSameOrBefore(moment(promotionEnd)) && promotionPrice < quantity.localPrice;
                            return (
                                quantity.onMenu ? (
                                    <div
                                        key={index}
                                        className="list-group-item defaultQuantity"
                                        style={{ background: this.getBackground(quantity.quantity), borderTop: "1px dashed gray" }}
                                        onClick={this.registerClick(d.entityType, d.id, quantity.quantity)}

                                    >
                                        {(capacity) ? <div className="capacity">{this.getCapacity(quantity.quantity)}</div> : null}
                                        {getAvailableQuantityLabel(d, quantity) !== "" && (
                                            <div className="quantity">
                                                <span>{getAvailableQuantityLabel(d, quantity)}</span>
                                                <br />
                                            </div>
                                        )}
                                        <div style={{ flexGrow: 1 }} />
                                        <div className="promotionWrapper">
                                            <div className={"price" + (activePromotion ? " discounted" : "")}>{auth.round(quantity.localPrice)}</div>
                                            {activePromotion && (
                                                <div className="price promotion">{auth.round(promotionPrice)}</div>
                                            )}
                                        </div>
                                        {quantity.localPrice !== quantity.takeawayPrice && (
                                            <div className="price icon-cup">{auth.round(quantity.takeawayPrice)}</div>
                                        )}
                                    </div>
                                ) : null
                            )
                        }
                        )}
                    </div>
                </li>
            )
        } else {
            return null;
        }
    }

    registerClick = (entityType, id, quantity) => {
        this.props.increaseHits && this.props.increaseHits();
        setTimeout(() => {
            if (this.props.autoClickFirst) {

                var force = false;
                var searchTermLower = this.props.searchTerm.toLowerCase();
                var open = !settingEnabled("shop-mode");
                if (searchTermLower.length === 13 && searchTermLower.startsWith('28')) {
                    const t = searchTermLower.substring(7, 12);
                    quantity = Number(t);
                    force = true;
                    open = false;
                    this.props.resetSelection && this.props.resetSelection();
                }

                orderMenuItem(true, entityType, id, quantity, force, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, open);
            }
        }, 100)
        return (event) => this.handleOrderClick(event, entityType, id, quantity);
    };
}

export const dateArray = (m) => {
    return Array.from({
        length: (m.defaultToDate - m.defaultFromDate) / (1000 * 60 * 60 * 24) + 1
    }, (_, index) => new Date(m.defaultFromDate + index * 24 * 60 * 60 * 1000)).map(d => d.getTime());
}


export default CategoryTemplate;
